import { render, staticRenderFns } from "./AboutLimePage.vue?vue&type=template&id=6d7176bb&scoped=true"
import script from "./AboutLimePage.vue?vue&type=script&lang=js"
export * from "./AboutLimePage.vue?vue&type=script&lang=js"
import style0 from "./AboutLimePage.vue?vue&type=style&index=0&id=6d7176bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7176bb",
  null
  
)

export default component.exports